export default __webpack_public_path__ + "static/media/drop.c547e366.svg";